import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from '@/components/common/ScrollToTop';
import { useUIStore } from '@/stores/ui';

// Lazy load MobileMenu since it includes heavy @headlessui/react (455KB)
// Only loads when user opens mobile menu
const MobileMenu = lazy(() => import('./MobileMenu').then(m => ({ default: m.MobileMenu })));

export function PublicLayout() {
  const isMobileMenuOpen = useUIStore((state) => state.isMobileMenuOpen);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <ScrollToTop />
      <Header />
      {/* Only render MobileMenu when needed */}
      {isMobileMenuOpen && (
        <Suspense fallback={null}>
          <MobileMenu />
        </Suspense>
      )}
      <main id="main-content" className="flex-1" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
